@let bgColor = readonlyConfig()?.bgColor;
@let cipoBgColorClass = bgColor ? `cipo-bg--${bgColor}` : null;

@if (config().type === CipoFieldTypes.Checkbox) {
    <cipo-outline-field [bgColorClass]="cipoBgColorClass">
        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon [color]="displayValue() ? 'accent' : 'disabled'">
                {{ displayValue() ? "check_box" : "check_box_outline_blank" }}
            </mat-icon>
            <p>{{ config().label | translate }}</p>
        </div>
    </cipo-outline-field>
} @else if (config().type === CipoFieldTypes.Attachment) {
    <!-- Used only for grid-form-view -->
    <cipo-attachment
        class="cipo--width--full"
        [attachments]="attachments()"
        [fieldData]="{ readonly: true, multiple: true, label: config().label, bgColor: bgColor }" />
} @else {
    <cipo-outline-field [bgColorClass]="cipoBgColorClass" [label]="config().label">
        <div fxLayout fxLayoutAlign="start center" class="cipo--width--full">
            @if (config().prefixIcon) {
                <mat-icon fxFlex="none">{{ config().prefixIcon }}</mat-icon>
            }

            @defer {
                <!-- We use $any to avoid errors for limited input types -->
                @switch (config().type) {
                    <!-- This field type is used only by grid-view component -->
                    @case (CipoFieldTypes.RichText) {
                        <div class="cipo--width--full cipo--overflow--hidden">
                            @if (displayOldValue()?.toString().length) {
                                <div class="multiple-value old-value">
                                    <app-froala [content]="$any(displayOldValue())" [editmode]="false" />
                                </div>
                            }
                            @if (displayValue()?.toString().length) {
                                <app-froala [content]="$any(displayValue())" [editmode]="false" />
                            }
                            @if (displayNewValue()?.toString().length) {
                                <div class="multiple-value new-value">
                                    <app-froala [content]="$any(displayNewValue())" [editmode]="false" />
                                </div>
                            }
                        </div>
                    }

                    <!-- This includes text & number -->
                    @default {
                        @if (
                            config().multiple ||
                            config().type === CipoFieldTypes.Listbox ||
                            config().type === CipoFieldTypes.Select ||
                            config().type === CipoFieldTypes.RadioGroup
                        ) {
                            <div
                                fxLayout="row wrap"
                                fxFlex="grow"
                                class="cipo--gap--xs"
                                [class.cipo--cursor--pointer]="clickable()"
                                (click)="handleClick()">
                                @if (displayOldValue()) {
                                    @for (oldItem of displayOldValue() || []; track $index) {
                                        <p class="multiple-value old-value">
                                            <ng-container
                                                [ngTemplateOutlet]="linkOrTextTemplate"
                                                [ngTemplateOutletContext]="{ $implicit: oldItem }" />
                                        </p>
                                    }
                                }
                                @if (displayValue()) {
                                    @for (item of displayValue() || []; track $index) {
                                        <p class="multiple-value">
                                            <ng-container
                                                [ngTemplateOutlet]="linkOrTextTemplate"
                                                [ngTemplateOutletContext]="{ $implicit: item }" />
                                        </p>
                                    }
                                }
                                @if (displayNewValue()) {
                                    @for (newItem of displayNewValue() || []; track $index) {
                                        <p class="multiple-value new-value">
                                            <ng-container
                                                [ngTemplateOutlet]="linkOrTextTemplate"
                                                [ngTemplateOutletContext]="{ $implicit: newItem }" />
                                        </p>
                                    }
                                }
                            </div>
                        } @else {
                            <p
                                fxFlex="grow"
                                fxLayoutGap="8px"
                                class="cipo--text--pre-line"
                                [class.cipo--cursor--pointer]="clickable()"
                                (click)="handleClick()">
                                @if (displayOldValue()) {
                                    <span class="old-value">
                                        <ng-container
                                            [ngTemplateOutlet]="linkOrTextTemplate"
                                            [ngTemplateOutletContext]="{ $implicit: displayOldValue() }" />
                                    </span>
                                }
                                @if (displayValue()) {
                                    <ng-container
                                        [ngTemplateOutlet]="linkOrTextTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: displayValue() }" />
                                }
                                @if (displayNewValue()) {
                                    <span class="new-value">
                                        <ng-container
                                            [ngTemplateOutlet]="linkOrTextTemplate"
                                            [ngTemplateOutletContext]="{ $implicit: displayNewValue() }" />
                                    </span>
                                }
                            </p>
                        }
                    }
                }
            } @placeholder {
                <ngx-skeleton-loader [theme]="{ width: '100%', height: '12px', margin: '0' }" />
            }
            @if (hasCopyableDisplayValue()) {
                <button mat-icon-button fxFlex="none" (click)="copyDisplayLinkValue($event)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            }
            @if (config().suffixIcon) {
                <mat-icon fxFlex="none">{{ config().suffixIcon }}</mat-icon>
            }
            @if (clickable()) {
                <button
                    mat-icon-button
                    fxFlex="none"
                    (click)="handleClick()"
                    [attr.aria-label]="
                        (clickableAddress() ? 'a11y.form.editLocation' : 'a11y.common.view') | translate
                    ">
                    @if (clickableAddress()) {
                        <mat-icon aria-hidden="true">location_on</mat-icon>
                    }
                </button>
            }
        </div>
    </cipo-outline-field>
}

<ng-template #linkOrTextTemplate let-value>
    @if (isLinkValue(value)) {
        <a [href]="getLinkHref(value)" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
            {{ $any(value) }}
        </a>
    } @else {
        {{ $any(value) }}
    }
</ng-template>
